import { createFileRoute } from '@tanstack/react-router'
import { Database } from 'lucide-react'
import { z } from 'zod'
import { MemoriesScreen } from '@/screens/workspace/SCR-003-memories'

export const Route = createFileRoute('/_app/w/$ws/memories')({
  staticData: { screen: {"id":"SCR-003","title":"Memory explorer","group":"Workspace","perm":"memory.read","order":4,"description":"Search, filter and inspect every memory in this workspace.", icon: Database } },
  validateSearch: z.object({
    q: z.string().max(500).optional(),
    scope: z.enum(['user', 'workspace', 'enterprise']).optional(),
    type: z.enum(['user', 'feedback', 'project', 'reference']).optional(),
    source: z.enum(['explicit', 'inferred']).optional(),
    status: z.enum(['active', 'ended', 'superseded']).optional(),
    owner: z.string().max(200).optional(),
    from: z.string().max(10).optional(),
    to: z.string().max(10).optional(),
  }),
  component: MemoriesScreen,
})
